import i18n from "../../../locales/i18n";
import {
  firstImageOfListingTemplateInput,
  includeBsadInput,
  mainListingInput,
  mainTemplateColorInput,
  realtorImageTemplateInput,
  includeRealtorImageInput,
  realtorLogoTemplateInput,
  realtorNameTemplateInput,
  realtorPhoneNumberTemplateInput,
  getBsadPrompt,
  getRealtorImagePrompt,
  getVerticalFooterPrompt,
  getVisualStylePrompt,
  getColorInfo,
  hasRealtorImage,
  promptGenerationFinalParams,
  templateDataType,
  promptGeneratorInitialParams
} from "../template_sections";

export const just_sold_var_1: templateDataType = {
  templateName: i18n.t("creativesGenerator.templates.justSold.templateName"),
  displayImageUrl: "/static/creative-template-display-images/real-estate-just-sold-1.jpg",
  description: i18n.t("creativesGenerator.templates.justSold.description"),
  inputs: [
    includeBsadInput,
    mainTemplateColorInput,
    mainListingInput,
    realtorNameTemplateInput,
    realtorPhoneNumberTemplateInput,
    realtorImageTemplateInput,
    includeRealtorImageInput,
    realtorLogoTemplateInput,
    firstImageOfListingTemplateInput,
    {
      label: i18n.t("creativesGenerator.templates.justSold.soldAnnouncementText"),
      type: "text",
      nameInPrompt: "sold_announcement_text",
      showInSection: "template_specific",
      description: i18n.t("creativesGenerator.templates.justSold.soldAnnouncementTextDescription"),
      defaultValue: (params: promptGeneratorInitialParams) => {
        const mainListing = params.selectedListings["main_listing"];
        return i18n.t("creativesGenerator.templates.justSold.soldAnnouncementTextDefaultValue", {
          city: mainListing?.address?.city ?? "_____"
        });
      }
    }
  ],
  promptGenerator: (params: promptGenerationFinalParams) => {
    const soldAnnouncementText = params.templateFinalInputs.find(
      (input) => input.nameInPrompt === "sold_announcement_text"
    )?.finalValue;

    const { mainColorValue, lighterColorValue, darkerColorValue } = getColorInfo(params);

    return `
{
  "project_context": {
    "type": "Real Estate Social Media Graphic",
    "purpose": "Celebratory 'Just Sold' announcement for a property",
    "tone": "Professional, vibrant, energetic, and successful",
    "aspect_ratio": "1:1 (Square)"
  },

  ${getVisualStylePrompt(params)},

  "composition_layers": {
    "background_layer": {
      "source": "listing_image",
      "instructions": "Place the provided house image as the full background. This should be the exact image provided"
    },
    "hero_typography_layer": {
      "text": "SOLD",
      "position": "Top center, floating",
      "style": "Massive 3D font. The face of the letters should be white with a pattern of small gold dots/halftones. The sides/extrusion of the letters should be a glossy metallic gold. Add a drop shadow to separate it from the background"
    },
    "secondary_banner_layer": {
      "position": "Lower third, floating above the grass but behind the realtor",
      "shape": "A white ribbon or torn-paper style banner with a slight 3D curl",
      "text_content": "${soldAnnouncementText}",
      "text_color": "vibrant ${mainColorValue}",
      "font_weight": "Bold/Heavy"
    },

    "foreground_effects_layer": {
      "elements": [
        "Floating ${lighterColorValue} colored leaves in the top-left, top-right, and mid-right edges to create a framing effect and depth of field (blurred foreground)",
        "Sun flare/burst effect positioned behind the 'SOLD' text"
      ]${getBsadPrompt(params, false)}
    },
    ${hasRealtorImage(params) ? `${getRealtorImagePrompt(
      params,
      `The realtor should overlap the footer and the banner slightly to create depth.`
    )},` : ""}
    ${getVerticalFooterPrompt(params)}
  },
  "provided_assets": {
    ${hasRealtorImage(params) ? `"realtor": "the realtor image (need to remove background from it)",` : ""}
    "logo": "the realtor logo",
    "house": "the image of the house"
  },
  "important_notes": [
    "Ensure the final image is vibrant and eye-catching to stand out on social media feeds",
    "Maintain a professional yet celebratory tone suitable for real estate marketing",
    "Do not alter the provided images beyond removing backgrounds and resizing/cropping as necessary for composition"
  ]
}
`;
  }
};
